/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {  useSelector } from 'react-redux';
import ExtensionWebpage from './extensionWebpage';
import ExtensionButton from './extensionButton';
import ExtensionCTA from './extensionCTA';
import ExtensionTimer from './extensionTimer';
import ExtensionMedia from './extensionMedia';
import { getWidgetCode } from '../../utils/util';
import ExtensionPlayYoutubeVideo from './extensionPlayYoutubeVideo';

const ExtensionHandler = () => {
  const extensionDetails =  useSelector(state => state.conf.extensionDetails);
  const screenDimension =  useSelector(state => state.conf.screenDimension);
  const timerExtensionDetails =  useSelector(state => state.conf.timerExtensionDetails);
  const [extensionIframe, setExtensionIframe] = useState(true);

  const extensionId = extensionDetails?.extensionid;
  useEffect(() => {
    if (extensionDetails?.extensionid === 52199) {
      const typeAudioVideo = /audio|video/i.test(extensionDetails?.type);
      if (typeAudioVideo) {
        // if (extensionDetails?.type?.includes('video')) {
        //   dispatch(setView(viewType.presentation));
        // } else {
        //   if (view === viewType.presentation && lastView) {
        //     dispatch(setView(lastView));
        //   }
        // }
        setExtensionIframe(false);
      } else {
        setExtensionIframe(true);
      }
    }
  }, [extensionDetails]);
  let { screenHeight, screenWidth } = screenDimension;
  const hideForAll = () => {

  };


  let extensionDisplay = '';

  if (extensionDetails?.extensionid === 36999) {
    extensionDisplay = !extensionDetails?.visible_to_guest ? 'none' : '';
  }
    const shouldHideExtension = () => {
    if (extensionId !== 36999) {
      return false;
    }
    return !extensionDetails.visible_to_guest;
  };

    const getDimension = (value, total) =>
    (total * (value > 100 || value < 0 ? 100 : value)) / 100;

  const displayWidth =
    extensionId === 36999
      ?  10.7
      : extensionDetails.width > 100 || extensionDetails.width < 0
      ? 100
      : extensionDetails.width;

  const isBottomButtonBar = extensionDetails?.extensionid === 26999 && extensionDetails?.layout === 'BottomBar';
  const isCtaButton =  extensionDetails?.extensionid === 66199 && extensionDetails?.bgLayout === 'PopUp';

  const handlerStyle = {
    height: isCtaButton
      ? `${getDimension(70, screenHeight)}px`
      : `${getDimension(extensionDetails?.height, screenHeight)}px`,
    width: `${getDimension(displayWidth, screenWidth)}px`,
    top: isBottomButtonBar
      ? 'auto'
      : isCtaButton
        ? `${getDimension(15, screenHeight)}px`
        : `${getDimension(extensionDetails?.top, screenHeight)}px`,
    bottom: isBottomButtonBar ? 0 : 'auto',
    left: isCtaButton
      ? `${getDimension(33, screenWidth)}px`
      : `${getDimension(extensionDetails?.left, screenWidth)}px`,
    position: 'absolute',
    opacity: 1,
    zIndex: extensionDetails?.extensionId === 73645  ? 0  : timerExtensionDetails?.extensionid === getWidgetCode('timer') && extensionId  ? 1  :  1,
    display: shouldHideExtension() ? 'none' : '',
    background: extensionId === 68099 ? '#fff' : undefined,
  };

  // const handlerStyle = {
  //   height: `${(screenHeight * (extensionDetails.height > 100 || extensionDetails.height < 0 ? 100 : extensionDetails.height)) / 100}px`,
  //   width: `${(screenWidth * (extensionDetails.width > 100 || extensionDetails.width < 0 ? 100 : extensionDetails.width)) / 100}px`,
  //   position: 'absolute',
  //   top: `${(screenHeight * (extensionDetails.top > 100 || extensionDetails.top < 0 ? 100 : extensionDetails.top)) / 100}px`,
  //   left: `${(screenWidth * (extensionDetails.left > 100 || extensionDetails.left < 0 ? 100 : extensionDetails.left)) / 100}px`,
  //   opacity: 1,
  //   zIndex: 1,
  //   display: extensionDisplay,
  //   background: extensionDetails?.extensionid === 68099 ? '#fff' : undefined,
  // };

  return (
    extensionIframe ?
      <div style={handlerStyle}>
        {extensionDetails?.extensionid === 26999 ? (
          <ExtensionButton extensionDetails={extensionDetails} />
        ) : extensionDetails?.extensionid === 66199 ? (
          <ExtensionCTA extensionDetails={extensionDetails} />
        ) : extensionDetails?.extensionid === 36999 ? (
          <ExtensionTimer extensionDetails={extensionDetails} hideForAll={hideForAll} />
        ) : extensionDetails?.extensionid === 52199 ? (
          <ExtensionMedia extensionDetails={extensionDetails} />
        ) : extensionDetails?.extensionid === 68099 ? (
          <ExtensionWebpage extensionDetails={extensionDetails} />
        ) 
        // : extensionDetails?.extensionid === 39016 ? (
        //   <ExtensionPlayYoutubeVideo extensionDetails={extensionDetails} />
        // )
         : <></>}
      </div> : <></>
  );
};

export default ExtensionHandler;
